import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';
import { PropertiesService } from '../services/properties.service';

@Injectable()
export class PropertiesStore {

    private loader: any = null;

    private dirty: boolean = false;

    // Note: progressivo dell'ultima richiesta che sostituisce l'elenco (load/refresh). Le risposte possono arrivare
    //       fuori ordine (es. ricerca durante la digitazione): quelle di richieste ormai superate vengono scartate.
    private querySeq: number = 0;

    private _category: string;
    private _showSales: boolean = true;
    private _showRentals: boolean = true;
    private _showSuspended: boolean = true;
    private _showHistoricized: boolean = false;
    private _orderBy: string = '';
    private _sortOrder: string = '';
    private _query: string = '';
    private _page: number = 0;  

    public data: any;  // Note(Moris): sarebbe meglio che data fosse di tipo "Array<PropertyModel>" o almeno "Array" 
    public showLoader: boolean = true;

    constructor(
        private service: PropertiesService,
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController) { }    

    // --- INIZIO ---
    // Todo : spostare questi quattro medodi in una classe base     

    private startLoad() {
        if (this.showLoader)
            this.presentLoading();
    }

    private endLoad() {
        if (this.loader)
            this.loader.dismiss();
    }

    private presentLoading() {

        this.loader = this.loadingCtrl.create({
            content: "Caricamento..."
        });
        this.loader.present();
    }

    private presentAlert(title: string, message: string) {

        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }

    // --- FINE ---

    get category(): string {
        return this._category;
    }

    set category(value: string) {

        // ToDo: validare 'category'
        if (value != this._category) {
            this._category = value;
            this.dirty = true;
        }
    }

    get showSales(): boolean {
        return this._showSales;
    }

    set showSales(value: boolean) {

        if (value != this._showSales) {
            this._showSales = value;
            this.dirty = true;
        }
    }

    get showRetals(): boolean {
        return this._showRentals;
    }

    set showRentals(value: boolean) {

        if (value != this._showRentals) {
            this._showRentals = value;
            this.dirty = true;
        }
    }

    get showSuspended(): boolean {
        return this._showSuspended;
    }

    set showSuspended(value: boolean) {

        if (value != this._showSuspended) {
            this._showSuspended = value;
            this.dirty = true;
        }
    }

    get showHistoricized(): boolean {
        return this._showHistoricized;
    }

    set showHistoricized(value: boolean) {

        if (value != this._showHistoricized){
            this._showHistoricized = value;
            this.dirty = true;
        }
    }

    get orderBy(): string {
        return this._orderBy;
    }

    set orderBy(value: string) {

        // ToDo: validare 'orderBy'
        if (value != this._orderBy) {
            this._orderBy = value;
            this.dirty = true;
        }
    }

    get sortOrder(): string {
        return this._sortOrder;
    }

    set sortOrder(value: string) {

        // ToDo: validare 'sortOrder'
        if (value != this._sortOrder) {
            this._sortOrder = value;
            this.dirty = true;
        }
    }

    get query(): string {
        return this._query;
    }

    set query(value: string) {

        if (value != this._query) {
            this._query = value;
            this.dirty = true;
        }
    }

    get page(): number {
        return this._page;
    }

    set page(value: number) {

        // ToDo: validare 'page''
        if (value != this._page) {
            this._page = Math.floor(value);
            this.dirty = true;
        }
    }

    private getParams(): Array<any> {
        
        let params: Array<any> = [];

        // Opzione
        if (this._showSales && this._showRentals)
            params.push({ option: '*' });
        else
        if (this._showSales)
            params.push({ option: 'V' });
        else
            params.push({ option: 'A' });

        // Sospesi        
        params.push({ showSuspended: this._showSuspended });

        // Storicizzati        
        params.push({ showHistoricized: this._showHistoricized });

        // Ordinamento
        if ('' != this._orderBy)
            params.push({ orderBy: this._orderBy });

        // Direzione ordinamento
        if ('' != this._sortOrder)
            params.push({ sortOrder: this._sortOrder });

        // Query full-text
        if ('' != this._query)
            params.push({ q: this._query });

        // Paginazione
        if (this._page > 0)
            params.push({ page: this._page });

        return params;
    }

    load() {

        // Note(Moris): ATTENZIONE - impedire l'accavallamento di richieste!
        // ToDo: gestire un flag per rieseguire una "load" se vi è una richiesta pendente
        // ToDo: porre "dirty" a "false" *solo* se non vi sono richieste pendenti        

        if (this.isEmpty() || this.isDirty()) {

            this.startLoad();

            let seq: number = ++this.querySeq;
            let params: Array<any> = this.getParams();
            let observable = this.service.list(this._category, params);

            observable.subscribe(
                data => {
                    if (seq == this.querySeq) {
                        this.data = data;
                        this.dirty = false;
                    }

                    this.endLoad();
                },
                error => {

                    // console.log('[PropertiesStore] load | error: ');
                    // console.log(error);

                    this.endLoad();
                    this.presentAlert('Error', 'Impossibile recuperare dal server la risorsa richiesta.');
                });

            return observable.toPromise();
        }

        return null; // ToDO: restituire comunque una "promise" !?
    }

    refresh(showLoader: boolean = true) {

        // Note(Moris): ATTENZIONE - impedire l'accavallamento di richieste!
        // ToDo: porre "dirty" a "false" *solo* se non vi sono richieste pendenti

        if (showLoader)
            this.startLoad();

        let seq: number = ++this.querySeq;
        let params: Array<any> = this.getParams();
        let observable = this.service.list(this._category, params);

        observable.subscribe(
            data => {
                if (seq == this.querySeq) {
                    this.data = data;
                    this.dirty = false;
                }

                this.endLoad();
            },
            error => {
                // console.log('[PropertiesStore] load | error: ');
                // console.log(error);

                this.endLoad();
                this.presentAlert('Error', 'Impossibile recuperare dal server la risorsa richiesta.');
            });

        return observable.toPromise();
    }

    nextPage(showLoader: boolean = false): any {

        if (showLoader)
            this.presentLoading();

        this._page++;
        let seq: number = this.querySeq;
        let params: Array<any> = this.getParams();
        let observable = this.service.list(this._category, params);

        observable.subscribe(
            data => {

                // Note: se nel frattempo è partita una nuova load/refresh la pagina appartiene a un elenco superato
                if (seq == this.querySeq) {

                    if (data && data.length > 0)
                    {
                        this.data = this.data.concat(data);
                    }

                    this.dirty = false;
                }

                if (this.loader)
                    this.loader.dismiss();
            },
            err => {

                // console.log('[PropertiesStore] nextPage | err: ');
                  // console.log(err);           

                if (this.loader)
                    this.loader.dismiss();

                this.presentAlert('Error', 'Impossibile recuperare dal server la risorsa richiesta.'); 
            });

        return observable.toPromise();
    }

    isEmpty(): boolean {
        return (!this.data) || (0 == this.data.length);
    } 

    isDirty(): boolean {
        return this.dirty;
    }

    get recordCount(): number {

        // ToDo: recuperare il *reale numero di record* di una ricerca e non quelli visibili (data.length)!!
        if (this.data)
            return this.data.length;

        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/stores/properties.store.ts